import { AnimatePresence, motion } from 'framer-motion'
import React, { Fragment, useEffect, useRef, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import styled from 'styled-components'

export default ({ lessonId }: { lessonId: number }) => {
  return (
    <Container>
      <iframe src={`${import.meta.env.VITE_APP_home}/1v1h5pages/student/newAfterClassReport/student?lessonId=${lessonId}&from=0&entrance_page=appCourseList`} frameBorder="0"></iframe>
    </Container>
  )
}

const Container = styled(motion.div)`
  height: 80vh;
  iframe {
    width: 100%;
    height: 100%;
  }
`
